/*
 *
 * TerminalConfiguration
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 11-Dec-2024
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  title: (id) => (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.title'
      defaultMessage='Terminal ID {id} - E-COMMERCE'
      values={{ id }}
    />
  ),
  paymentNotifications: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.paymentNotifications'
      defaultMessage='Payment Notifications'
    />
  ),
  email: (
    <PortalMessage id='t.app.terminalsManagement.terminalConfiguration.email' defaultMessage='Notification email' />
  ),  //UTILIZZATO ANCHE IN DISPUTELESS
  notificationEmail: <PortalMessage id='t.app.terminalsManagement.disputeless.details.Email' defaultMessage='Email' />,
  requestorURL: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.requestorURL'
      defaultMessage='3DS Requestor URL'
    />
  ),
  requestorURLError: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.requestorURL.error'
      defaultMessage='Enter a valid format'
    />
  ),
  promptPaymentNotifications: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.promptPaymentNotifications'
      defaultMessage='Set the email address for receving payment notifications (only one allowed)'
    />
  ),
  promptCustomerPaymentNotifications: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.promptCustomerPaymentNotifications'
      defaultMessage='Would you like to send payment notifications to your customers?'
    />
  ),
  cancel: <PortalMessage id='t.app.project.btn.cancel' defaultMessage='Cancel' />,
  confirm: <PortalMessage id='t.app.project.btn.save' defaultMessage='Save' />,
  validEmail: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.validEmail'
      defaultMessage='Enter a valid email'
    />
  ),
  customerPaymentNotifications: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.customerPaymentNotifications'
      defaultMessage='Send customer payment notifications'
    />
  ),
  confirmationType: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.confirmationType'
      defaultMessage='Confirmation Type'
    />
  ),
  deferredDays: (
    <PortalMessage id='t.app.terminalsManagement.terminalConfiguration.deferredDays' defaultMessage='Deferred days' />
  ),
  paymentExecution: (
    <PortalMessage
      id='t.app.terminalsManagement.terminalConfiguration.paymentExecution'
      defaultMessage='Payment capture'
    />
  ),
  enabled: <PortalMessage id='t.app.terminalsManagement.terminalConfiguration.enabled' defaultMessage='Enabled' />,
  disabled: <PortalMessage id='t.app.terminalsManagement.terminalConfiguration.disabled' defaultMessage='Disabled' />,
  done: <PortalMessage id='t.app.settings.editTerminalResult.success.done' defaultMessage='Done!' />,
  successMessage: (
    <PortalMessage
      id='t.app.settings.editTerminalResult.success.successMessage'
      defaultMessage='Terminal configured successfully'
    />
  ),
  goToSettings: (
    <PortalMessage id='t.app.settings.editTerminalResult.success.goToSettings' defaultMessage='Go to Settings' />
  ),
  errorTitle: (
    <PortalMessage
      id='t.app.settings.editTerminalResult.error.errorTitle'
      defaultMessage='Oops! Something went wrong'
    />
  ),
  errorMessage: (
    <PortalMessage
      id='t.app.settings.editTerminalResult.error.errorMessage'
      defaultMessage='We apologize for the technical issues. Please try again later.'
    />
  ),
  retry: <PortalMessage id='t.app.settings.editTerminalResult.error.retry' defaultMessage='Retry' />,
  close: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' />
}

export const messages = {
  yes: { id: 't.app.project.btn.yes', defaultMessage: 'Yes' },
  no: { id: 't.app.project.btn.no', defaultMessage: 'No' },
  explicit: {
    id: 't.app.terminalsManagement.terminalConfiguration.captureType.manual',
    defaultMessage: 'Manual'
  },
  implicit: {
    id: 't.app.terminalsManagement.terminalConfiguration.captureType.automatic',
    defaultMessage: 'Automatic'
  },
  deferred: { id: 't.app.terminalsManagement.terminalConfiguration.captureType.deferred', defaultMessage: 'Deferred' },
  edit: { id: 't.app.terminalsManagement.terminalConfiguration.edit', defaultMessage: 'Manage' },
  tooltipCustomerConfirmationTypeTitle: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeTitle',
    defaultMessage: 'Configure the default payment capture mode:'
  },
  tooltipCustomerConfirmationTypeList1Title: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList1Title',
    defaultMessage: 'Automatic (Implicit):'
  },
  tooltipCustomerConfirmationTypeList1Description: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList1Description',
    defaultMessage: 'Automatically confirms authorizations.'
  },
  tooltipCustomerConfirmationTypeList2Title: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList2Title',
    defaultMessage: 'Manual (Explicit):'
  },
  tooltipCustomerConfirmationTypeList2Description: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList2Description',
    defaultMessage: 'Requires manual confirmation of authorizations.'
  },
  tooltipCustomerConfirmationTypeList3Title: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList3Title',
    defaultMessage: 'Deferred: '
  },
  tooltipCustomerConfirmationTypeList3Description: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList3Description',
    defaultMessage: 'Automatically confirms authorizations after the specified number of days.'
  },
  tooltipCustomerConfirmationTypeList4Title: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList4Title',
    defaultMessage: 'Please note: '
  },
  tooltipCustomerConfirmationTypeList4Description: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerConfirmationTypeList4Description',
    defaultMessage:
      'The default capture mode is always available for card payments. Most alternative payment methods (APMs) are captured automatically, independently of the default mode settings.'
  },
  tooltipNotifications: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipNotifications',
    defaultMessage:
      'Indicate on which email address you want to receive notifications. Only one email address can be set'
  },
  tooltipCustomerNotifications: {
    id: 't.app.terminalsManagement.terminalConfiguration.tooltipCustomerNotifications',
    defaultMessage: 'Send customers an email receipt after payment.'
  },
  confirmationType: {
    id: 't.app.terminalsManagement.terminalConfiguration.confirmationType',
    defaultMessage: 'Confirmation Type'
  },
  deferredDays: {
    id: 't.app.terminalsManagement.terminalConfiguration.deferredDays',
    defaultMessage: 'Deferred days'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  email: {
    id: 't.app.terminalsManagement.terminalConfiguration.email',
    defaultMessage: 'Email'
  },
  sendPaymentNotifications: {
    id: 't.app.terminalsManagement.terminalConfiguration.sendPaymentNotifications',
    defaultMessage: 'Send payment notifications'
  },
  promptPaymentNotifications: {
    id: 't.app.terminalsManagement.terminalConfiguration.promptPaymentNotifications',
    defaultMessage: 'Set the email address for receving payment notifications (only one allowed)'
  },
  enabled: { id: 't.app.terminalsManagement.terminalConfiguration.enabled', defaultMessage: 'Enabled' },
  disabled: { id: 't.app.terminalsManagement.terminalConfiguration.disabled', defaultMessage: 'Disabled' },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  },
  requestorURL: {
    id: 't.app.terminalsManagement.terminalConfiguration.requestorURL',
    defaultMessage: '3DS Requestor URL'
  }
}

export default formattedMessage
